import { CommonModule } from '@angular/common';
import { Component, inject, output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Icon } from '@hello-unicorn/client-libs';
import { SettingStore } from '../../../stores/setting.store';

/**
 * 사이드바 메뉴 아이템 인터페이스
 */
interface MenuItem {
  /** 메뉴 라벨 */
  label: string;
  /** 라우터 경로 */
  path: string;
  /** 아이콘 이름 (iconify) */
  icon: string;
  /** 추가 활성화 경로 (서브 경로 등) */
  activePaths?: string[];
}

/**
 * 사이드바 컴포넌트
 * @description 메인 레이아웃의 사이드바 네비게이션을 담당
 * @author 정정용 <jeongyong@lepisode.team>
 */
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  imports: [RouterLink, RouterLinkActive, Icon, CommonModule],
})
export class SidebarComponent {
  readonly closeSidebar = output<void>();
  protected readonly settingStore = inject(SettingStore);
  private readonly router = inject(Router);

  /**
   * X 버튼 클릭 시 사이드바 닫기
   */
  onCloseSidebar() {
    this.closeSidebar.emit();
  }

  /**
   * 메뉴 아이템 목록
   */
  readonly menuItems: MenuItem[] = [
    {
      label: 'AI 기반 금융지원 모델 결과 미리보기',
      path: '/',
      icon: 'mdi:eye-outline',
    },
    {
      label: 'AI 기반 금융지원 모델 사용하기',
      path: '/index',
      icon: 'mdi:file-document-outline',
      activePaths: ['/index', '/report'],
    },
  ];

  /**
   * 설정 아이템 목록
   */
  readonly settingItems: MenuItem[] = [
    {
      label: '설정',
      path: '/setting',
      icon: 'mdi:cog-outline',
    },
    {
      label: '알림',
      path: '/notification',
      icon: 'mdi:bell',
    },
  ];

  /**
   * 추가 경로가 활성화되었는지 확인
   * @param item 메뉴 아이템
   */
  isSubPathActive(item: MenuItem): boolean {
    if (!item.activePaths) return false;
    return item.activePaths.some(path => this.router.isActive(path, false));
  }
}
